import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ConfigService } from "./config.service";
import { CalendarEntry } from "../models/calendar/calendar-entry";
import { CalendarItemPostModel, CalendarPost } from "../models/calendar/calendar-post";
import { CalendarItem } from "../models/calendar/calendar-item";
import { CalendarItemAssignOrganisationUserPost } from "../models/calendar/calendar-item-assign-organisation-user-post";
import {
    OrganisationPersonCalendarAuthInterface
} from "../models/organisation/organisation-person-calendar-auth.interface";

@Injectable()
export class CalendarService {
    constructor(private http: HttpClient, private configService: ConfigService) {
    }

    getCalendarItem(organisationReference: string, calendarItemReference: string) {
        return this.http.get<CalendarItem>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-items/${calendarItemReference}`, {});
    }

    getCalendarItemEntries(organisationReference: string, fromDate: string) {
        const params = new HttpParams().set('fromDate', fromDate);
        return this.http.get<CalendarEntry[]>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-items`, {params});
    }

    addCalendarItem(organisationReference: string, model: CalendarItemPostModel) {
        return this.http.post<CalendarEntry>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-items`, model);
    }

    editCalendarItem(organisationReference: string, calendarItemReference: string, model: CalendarItemPostModel) {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-items/${calendarItemReference}`;
        return this.http.patch<CalendarEntry>(url, model);
    }

    deleteCalendarItem(organisationReference: string, calendarItemReference: string) {
        return this.http.delete<CalendarItem>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-items/${calendarItemReference}`);
    }

    patchAssignedOrganisationPerson(organisationReference: string, calendarItemReference: string, model: CalendarItemAssignOrganisationUserPost){
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-items/${calendarItemReference}/assign`
        return this.http.patch<CalendarItem>(url, model);
    }

    getViewingEntries(organisationReference: string, fromDate: string) {
        const params = new HttpParams().set('fromDate', fromDate);
        return this.http.get<CalendarEntry[]>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/property-viewings`, {params});
    }

    getMaintenanceEntries(organisationReference: string, fromDate: string) {
        const params = new HttpParams().set('fromDate', fromDate);
        return this.http.get<CalendarEntry[]>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/maintenance-issues`, {params});
    }

    getActionEntries(organisationReference: string, fromDate: string) {
        const params = new HttpParams().set('fromDate', fromDate);
        return this.http.get<CalendarEntry[]>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/actions`, {params});
    }

    getTenancyEntries(organisationReference: string, fromDate: string) {
        const params = new HttpParams().set('fromDate', fromDate);
        return this.http.get<CalendarEntry[]>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/tenancies`, {params});
    }

    // ICAL Functions

    getICalAuths(organisationReference: string) {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/ical-urlstrings`
        return this.http.get<OrganisationPersonCalendarAuthInterface[]>(url, {});
    }

    generateOrganisationPersonCalendarAuthentication(organisationReference: string, model: CalendarPost) {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-auth`
        return this.http.post<OrganisationPersonCalendarAuthInterface>(url, model);
    }

    revokeOrganisationPersonCalendarAuthentication(organisationReference: string, authGuid: string, revoke: boolean){
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-auth/${authGuid}`
        let params = new HttpParams();
        params = params.append('revoke', revoke);
        return this.http.patch<OrganisationPersonCalendarAuthInterface>(url, null, {params});
    }

    deleteOrganisationPersonCalendarAuthentication(organisationReference: string, authGuid: string){
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/calendar/calendar-auth/delete/${authGuid}`
        return this.http.patch<OrganisationPersonCalendarAuthInterface>(url, null);
    }
}
